(function () {
  function init() {
    var wrap = document.querySelector('[data-section]');
    if (!wrap) return;
    var sectionId = wrap.dataset.section;

    var jsonEl = document.getElementById('RvtProductJson-' + sectionId);
    if (!jsonEl) return;
    var variants = JSON.parse(jsonEl.textContent);

    var variantSelect = document.getElementById('Variants-' + sectionId);
    var priceEl = document.getElementById('Price-' + sectionId);
    var atcBtn = wrap.querySelector('[data-atc-btn]');

    // ── Variant change ──
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        var id = parseInt(this.value);
        var variant = variants.find(function (v) { return v.id === id; });
        if (!variant) return;
        updatePrice(variant);
        updateAtcBtn(variant);
        updateStickyAtc(variant);
      });
    }

    function updatePrice(variant) {
      if (!priceEl) return;
      var html = '';
      if (variant.compare_at_price > variant.price) {
        html += '<s class="rvt-product__price-compare">' + variant.compare_at_price_formatted + '</s>';
        html += '<span class="rvt-product__price-sale">' + variant.price_formatted + '</span>';
      } else {
        html += '<span class="rvt-product__price-main">' + variant.price_formatted + '</span>';
      }
      var vatEl = priceEl.querySelector('.rvt-product__price-vat');
      priceEl.innerHTML = html;
      if (vatEl) priceEl.appendChild(vatEl);
    }

    function updateAtcBtn(variant) {
      if (!atcBtn) return;
      atcBtn.disabled = !variant.available;
      atcBtn.textContent = variant.available ? (atcBtn.dataset.label || 'SEPETE EKLE') : 'STOKTA YOK';
    }

    function updateStickyAtc(variant) {
      var sticky = document.querySelector('[data-sticky-atc]');
      if (!sticky) return;
      var variantEl = sticky.querySelector('[data-sticky-variant]');
      var priceEl2 = sticky.querySelector('[data-sticky-price]');
      if (variantEl) variantEl.textContent = variant.title === 'Default Title' ? '' : variant.title;
      if (priceEl2) priceEl2.textContent = variant.price_formatted;
    }

    // ── Qty ±  ──
    var qtyInput = wrap.querySelector('.rvt-product__qty-input');
    wrap.querySelectorAll('[data-qty-minus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var v = parseInt(qtyInput.value) || 1;
        if (v > 1) qtyInput.value = v - 1;
      });
    });
    wrap.querySelectorAll('[data-qty-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        qtyInput.value = (parseInt(qtyInput.value) || 1) + 1;
      });
    });

    // ── Lightbox ──
    var lightbox = document.querySelector('[data-lightbox]');
    if (lightbox) {
      var lbImg = lightbox.querySelector('[data-lightbox-img]');

      wrap.querySelectorAll('[data-zoom]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          var imgWrap = btn.closest('[data-img-src]');
          var src = imgWrap ? imgWrap.dataset.imgSrc : '';
          if (lbImg && src) { lbImg.src = src; lbImg.alt = ''; }
          lightbox.setAttribute('data-open', '');
          lightbox.removeAttribute('aria-hidden');
          document.body.style.overflow = 'hidden';
          var closeBtn = lightbox.querySelector('[data-lightbox-close]');
          if (closeBtn) closeBtn.focus();
        });
      });

      // Click image wrap to zoom too
      wrap.querySelectorAll('.rvt-product__img-wrap').forEach(function (imgWrap) {
        imgWrap.addEventListener('click', function () {
          var src = this.dataset.imgSrc;
          if (lbImg && src) { lbImg.src = src; lbImg.alt = ''; }
          lightbox.setAttribute('data-open', '');
          lightbox.removeAttribute('aria-hidden');
          document.body.style.overflow = 'hidden';
          var closeBtn = lightbox.querySelector('[data-lightbox-close]');
          if (closeBtn) closeBtn.focus();
        });
      });

      function closeLightbox() {
        lightbox.removeAttribute('data-open');
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }

      lightbox.querySelector('[data-lightbox-close]').addEventListener('click', closeLightbox);
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox) closeLightbox();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && lightbox.hasAttribute('data-open')) closeLightbox();
      });
    }

    // ── Carousel ──
    var carousel = document.querySelector('[data-carousel]');
    if (carousel) {
      var track = carousel.querySelector('[data-carousel-track]');
      var prevBtn = carousel.querySelector('[data-carousel-prev]');
      var nextBtn = carousel.querySelector('[data-carousel-next]');
      var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-carousel-dot]'));
      var slideCount = track ? track.children.length : 0;

      function slideWidth() {
        return track && track.children[0] ? track.children[0].getBoundingClientRect().width : 0;
      }

      function currentIndex() {
        var w = slideWidth();
        return w ? Math.round(track.scrollLeft / w) : 0;
      }

      function goTo(index) {
        if (!track || slideCount === 0) return;
        var wrapped = ((index % slideCount) + slideCount) % slideCount;
        track.scrollTo({ left: wrapped * slideWidth(), behavior: 'smooth' });
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentIndex() - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIndex() + 1); });

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          goTo(parseInt(dot.dataset.carouselDot, 10));
        });
      });

      function updateState() {
        var idx = currentIndex();
        dots.forEach(function (dot, i) {
          if (i === idx) {
            dot.setAttribute('data-active', '');
            dot.setAttribute('aria-selected', 'true');
          } else {
            dot.removeAttribute('data-active');
            dot.setAttribute('aria-selected', 'false');
          }
        });
      }

      if (track && slideCount > 1) {
        var ticking = false;
        track.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            updateState();
            ticking = false;
          });
        }, { passive: true });
        updateState();
      }
    }

    // ── Share ──
    var shareBtn = wrap.querySelector('[data-share-btn]');
    var shareMsg = wrap.querySelector('[data-share-msg]');
    if (shareBtn) {
      shareBtn.addEventListener('click', function () {
        var url = this.dataset.shareUrl;
        var title = this.dataset.shareTitle;
        if (navigator.share) {
          navigator.share({ title: title, url: url }).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () { flashMsg(); });
        } else {
          var ta = document.createElement('textarea');
          ta.value = url;
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
          flashMsg();
        }
      });

      function flashMsg() {
        if (!shareMsg) return;
        shareMsg.setAttribute('data-visible', '');
        setTimeout(function () { shareMsg.removeAttribute('data-visible'); }, 2000);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
